var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoEyeBlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.79,
    height: 20.774,
    viewBox: "0 0 16.79 20.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#cbcdd4}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3158",
    transform: "translate(-767 -604.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_eye_888692_000000",
    transform: "translate(752.418 581.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1309",
    d: "M22.977 27.082c-4.938 0-8.4 5.432-8.4 5.432s2.518 5.432 8.4 5.432c5.926 0 8.4-5.432 8.4-5.432s-3.412-5.432-8.4-5.432zm0 8.889a3.456 3.456 0 1 1 3.456-3.456 3.435 3.435 0 0 1-3.456 3.456z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1310",
    d: "M47.5 45.624a1.874 1.874 0 1 1-1.874-1.874 1.873 1.873 0 0 1 1.874 1.874",
    className: "cls-1",
    transform: "translate(-22.647 -13.11)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_150",
    fill: "none",
    stroke: "#cbcdd4",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M0 0L12 18",
    transform: "translate(769.5 605.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoEyeBlocked);
export default __webpack_public_path__ + "static/media/picto-eye-blocked.c5a8e8f8d8e1c54bd380cb4331f018e8.svg";
export { ForwardRef as ReactComponent };